/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiScalesToolRegistration, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ScalesRegistrationsController.
 */
export class ScalesRegistrationsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /scale_tools:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiScalesToolRegistration>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiScalesToolRegistration>>>('/scale_tools:query', query);
    }

    /**
     * Calls POST /scale_tools:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiScalesToolRegistration>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiScalesToolRegistration>>, ListRequest>('/scale_tools:query', listRequest, query);
    }

    /**
     * Calls POST /scale_tools:prefill
     */
    public createPrefilled(): Promise<Result<ApiScalesToolRegistration>> {
        return this.http.post<Result<ApiScalesToolRegistration>, undefined>('/scale_tools:prefill', undefined);
    }

    /**
     * Calls POST /scale_tools/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiScalesToolRegistration>>> {
        return this.http.post<Result<LockedContextDto<ApiScalesToolRegistration>>, undefined>(`/scale_tools/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /scale_tools/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiScalesToolRegistration>> {
        return this.http.post<Result<ApiScalesToolRegistration>, undefined>(`/scale_tools/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /scale_tools/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiScalesToolRegistration[]>> {
        return this.http.post<Result<ApiScalesToolRegistration[]>, string[]>('/scale_tools/locks', ids);
    }

    /**
     * Calls POST /scale_tools/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/scale_tools/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /scale_tools/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/scale_tools/${primaryId}/locks`);
    }

    /**
     * Calls GET /scale_tools/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiScalesToolRegistration>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiScalesToolRegistration>>(`/scale_tools/${primaryId}`, query);
    }

    /**
     * Calls POST /scale_tools
     */
    public add(dto: ApiScalesToolRegistration): Promise<Result<ApiScalesToolRegistration>> {
        return this.http.post<Result<ApiScalesToolRegistration>, ApiScalesToolRegistration>('/scale_tools', dto);
    }

    /**
     * Calls PUT /scale_tools/{primaryId}
     */
    public update(dto: ApiScalesToolRegistration, primaryId: string): Promise<Result<ApiScalesToolRegistration>> {
        return this.http.put<Result<ApiScalesToolRegistration>, ApiScalesToolRegistration>(`/scale_tools/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /scale_tools
     */
    public putRange(dtos: ApiScalesToolRegistration[]): Promise<Result<ApiScalesToolRegistration[]>> {
        return this.http.patch<Result<ApiScalesToolRegistration[]>, ApiScalesToolRegistration[]>('/scale_tools', dtos);
    }

    /**
     * Calls DELETE /scale_tools/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/scale_tools/${primaryId}`);
    }

    /**
     * Calls POST /scalesregistrations:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiScalesToolRegistration>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiScalesToolRegistration>>, ListRequestWithIds>('/scalesregistrations:batch', listRequest, query);
    }
}
